import cn from "classnames";
import React from "react";
import { checkDate, checkMonth } from "Shared/Utils/dashboard";
import styles from "./VehicleAssignment.module.scss";

const useCalendar = () => {
  const getDateLogicLine = (
    row: any,
    column: any,
    onItemClick?: (id: string) => void,
  ) => {
    return row.data?.map((el: any, index: number) => {
      return checkDate(column.date, el.start_datetime, el.end_datetime).date ? (
        <div
          key={el.id}
          onClick={() => onItemClick?.(el.id)}
          className={cn(
            styles.item,
            checkDate(column.date, el.start_datetime, el.end_datetime)
              .rightBorder && styles[`item_rightBorder`],
            checkDate(column.date, el.start_datetime, el.end_datetime)
              .leftBorder && styles[`item_leftBorder`],
          )}
          style={{ top: `${index * 26}px` }} 
        />
      ) : (
        <div key={el.id} />
      );
    });
  };

  const getMonthLogicLine = (
    row: any,
    column: any,
    onItemClick?: (id: string) => void,
  ) => {
    return row.data?.map((el: any, index: number) => {
      return checkMonth(column.month, el.start_datetime, el.end_datetime)
        .month ? (
        <div
          key={el.id}
          onClick={() => onItemClick?.(el.id)}
          className={cn(
            styles.item,
            checkMonth(column.month, el.start_datetime, el.end_datetime)
              .rightBorder && styles[`item_rightBorder`],
            checkMonth(column.month, el.start_datetime, el.end_datetime)
              .leftBorder && styles[`item_leftBorder`],
          )}
          style={{ top: `${index * 26}px` }}
        />
      ) : (
        <div key={el.id} />
      );
    });
  };

  return { getDateLogicLine, getMonthLogicLine };
};

export default useCalendar;